import { useState, useCallback } from "react";
import { DateValueType } from "react-tailwindcss-datepicker/dist/types";
import dayjs from "dayjs";

export const useDateRangeFilter = () => {
  const [value, setValue] = useState<DateValueType>({
    startDate: dayjs().subtract(7, "day").toDate(),
    endDate: new Date(),
  });

  const onChange = useCallback((dateRange: DateValueType) => {
    setValue(dateRange);
  }, []);

  return {
    value,
    onChange,
  };
};
